import { childhoodHomeVariantCollection } from '@/components/CharacterGenerator/constants/childhoodHomeVariantList'

export default ({ childhoodHomeId }) => `Дом детства: ${childhoodHomeVariantCollection[childhoodHomeId].name}`
